import React from 'react';
import {useTranslation} from 'react-i18next';

import {Button} from '@edna/components';
import {H2, Stack} from '@edna/components/primitives';

import {TWhatsAppChannel} from 'src/containers/WhatsAppChannel/definitions';
import {useEdnaLinks} from 'src/hooks';

import {ChannelMessagingLimit} from './MessagingLimit';
import {ChannelQualityScore} from './QualityScore';
import * as S from './style';

type TProps = {
  item: TWhatsAppChannel;
};

const ChannelFlaggedMessage = React.memo<TProps>(({item}) => {
  const {t} = useTranslation();

  const links = useEdnaLinks();

  return (
    <S.Message>
      <S.StatusIcon name="error" />
      <S.Content>
        <Stack size="5">
          <Stack size="4">
            <Stack size="2">
              <H2>{t('Channels:flaggedChannel')}</H2>
              <S.Text>{t('Channels:flaggedChannelDescription')}</S.Text>
            </Stack>
            <Stack size="2">
              <ChannelQualityScore item={item} />
              <ChannelMessagingLimit item={item} />
            </Stack>
          </Stack>
          <Button
            as="a"
            href={links.CHANNEL_QUALITY_WA}
            target="_blank"
            rel="noopener noreferrer"
            appearance="primary"
          >
            {t('Common:more')}
          </Button>
        </Stack>
      </S.Content>
    </S.Message>
  );
});

ChannelFlaggedMessage.displayName = 'ChannelFlaggedMessage';

export {ChannelFlaggedMessage};
